<template>
  <div v-if="!hideBar"
       style="width: 100%">
    <v-divider v-if="!dividerPos || dividerPos ==='top'" />
    <div v-if="editMode || permanent"
         class="d-flex justify-space-between pa-2">
      <slot name="cancelbtn">
        <v-btn color="close"
               :outlined="!iconmode"
               :icon="iconmode"
               small
               :elevation="0"
               @click="toggleEdit()">
          {{iconmode ? '' : ($t('servicesystem.common_objects.commonterms.cancel'))}}
          <v-icon size="17">mdi-close</v-icon>
        </v-btn>
      </slot>
      <slot name="savebtn">
        <v-btn @click="saveable ? emitSave() : null"
               :color="saveable ? 'primary' : 'disabled'"
               :icon="iconmode"
               small
               :elevation="0">
          {{iconmode ? '' : (saveText ? saveText : $t('servicesystem.common_objects.commonterms.save'))}}
          <v-icon size="17">mdi-check</v-icon>
        </v-btn>
      </slot>
    </div>
    <v-divider v-if="dividerPos ==='bottom'" />
  </div>
</template>


<script>
export default {
  name: "EditBar",
  props: ["externalTrigger", "saveable", "hideBar", "permanent", "dividerPos", "saveText", "iconmode"],

  data: () => ({ editMode: false }),

  mounted() {
    if (this.externalTrigger) {
      this.editMode = true;
    }
  },

  methods: {
    toggleEdit() {
      this.editMode = !this.editMode;
      this.emitMode();
    },

    emitMode() {
      this.$emit("modeEmit");
    },

    emitSave() {
      this.$emit("saveEmit");
    },
  },

  computed: {},

  watch: {
    externalTrigger: function () {
      this.editMode = this.externalTrigger;
    },
  },
};
</script>